export default __webpack_public_path__ + "static/media/IMG_4472.12453d15.jpg";